export class User {
  id?: number;
  roleId?: number;
  customerId?: number;
  firstName: string;
  lastName: string;
  email: string;
  phone?: string;
  address1?: string;
  address2?: string = '';
  city?: string;
  state?: string;
  zipcode?: string;
  token?: string;
  memberPracticeList?: any[];
  accountLocked?: boolean = false;
  emailVerified?: boolean = false;
  passwordResetTokenExpiryDate?: string;
  roleName?: string;
  practiceId?: number;
}

export class CreateMemberCommand {
  email: string;
  memberDetail: MemberDto[];
  userType: number;
}
 export class MemberDto{
  roleId: number;
  practiceId: number
 }
export class UpdateMemberCommand {
  id: number;
  firstName: string;
  lastName: string;
  email: string;
  memberDetail: MemberDto[];
  userType: number;
  defaultPracticeId?: number;  
}
export class DeleteMemberCommand {
  memberId: number;
  practiceId: number;
}
export class InviteUser {
  id?: number;
  roleId: number;
  customerId?: number;
  practiceId?: number;
  email?: string;
  inviteValidUntil: string;
  isForever?: boolean = false;
  memberPracticeList?: any[];
}

export class MemberReqCommand {
  searchTerm: string = '';
  sortBy: number = 2;
  sortFieldName: string = 'id';
  pageNumber: number = 1;
  pageSize: number = 15;
  practiceId?: number = 0;
}
export class SendOtpForUpdateEmailReq{
  email?:string;
  newEmail?:string;
  contactName?:string;
}
export class UpdateEmailReq{
  oldEmail:string;
  email:string;
  practiceId:number;
}

export class InvitedMemberCommand {
  searchTerm: string = '';
  sortBy: number = 2;
  sortFieldName: string = 'id';
  pageNumber: number = 1;
  pageSize: number = 15;
}

export class InvitedMemberResponse {
  id: number;
  roleId: number;
  roleName: string;
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  userName: string;
  status?: string;
  statusName?: string;
  isResendEnable?: boolean;
  isDeleteEnable?: boolean;
  expiredDate?: Date;
}

export class ReceivedMemberCommand {
  searchTerm: string = '';
  sortBy: number = 1;
  sortFieldName: string = 'id';
  pageNumber: number = 1;
  pageSize: number = 15;
}